import type * as Types from '../../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GuestIdentificationEligibilityQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
}>;

export type GuestIdentificationEligibilityQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    info: { __typename?: 'EventInfo'; id: string; eventType: Types.EventType };
    settings: { __typename?: 'EventSettings'; id: string; requiresGuestIdentification: boolean };
    activeSession: { __typename?: 'EventSession'; id: string; hasIdentity: boolean; person?: { __typename?: 'Person'; id: string; fullName?: string | null } | null };
  } | null;
};

export const GuestIdentificationEligibilityDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GuestIdentificationEligibility' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'requiresGuestIdentification' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activeSession' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasIdentity' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'person' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGuestIdentificationEligibilityQuery__
 *
 * To run a query within a React component, call `useGuestIdentificationEligibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestIdentificationEligibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestIdentificationEligibilityQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGuestIdentificationEligibilityQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GuestIdentificationEligibilityQuery, GuestIdentificationEligibilityQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GuestIdentificationEligibilityQuery, GuestIdentificationEligibilityQueryVariables>(GuestIdentificationEligibilityDocument, baseOptions);
}
export function useGuestIdentificationEligibilityLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GuestIdentificationEligibilityQuery, GuestIdentificationEligibilityQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GuestIdentificationEligibilityQuery, GuestIdentificationEligibilityQueryVariables>(GuestIdentificationEligibilityDocument, baseOptions);
}
export type GuestIdentificationEligibilityQueryHookResult = ReturnType<typeof useGuestIdentificationEligibilityQuery>;
export type GuestIdentificationEligibilityLazyQueryHookResult = ReturnType<typeof useGuestIdentificationEligibilityLazyQuery>;
export type GuestIdentificationEligibilityQueryResult = Apollo.QueryResult<GuestIdentificationEligibilityQuery, GuestIdentificationEligibilityQueryVariables>;
